module.exports = __webpack_public_path__ + "img/poltas.e0427a1d.png";